import { renderButton_unstable } from "@fluentui/react-components";
import { AppTooltipContainer } from "@1js/acui-tooltip";
import type {
  AppPaddleButtonProps,
  AppPaddleButtonState,
} from "./AppPaddleButton.types";
import * as React from "react";

export const renderAppPaddleButton = (
  state: AppPaddleButtonState,
  props: AppPaddleButtonProps
) => {
  return (
    <AppTooltipContainer {...props}>
      {renderButton_unstable(state)}
    </AppTooltipContainer>
  );
};
